import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,_vm._b({ref:"select",attrs:{"label":_vm.labelAttr,"autocomplete":"off","append-icon":_vm.appendIcon,"data-test":_vm.dataTestAttr,"outlined":!_vm.inPlace,"menu-props":_vm.menuProps,"rules":_vm.mergedRules},on:{"input":function($event){return _vm.$emit('input', $event)},"click:clear":_vm.onClear}},'v-select',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }